import 'react-loading-skeleton/dist/skeleton.css'
import 'react-tabs/style/react-tabs.css';
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import './styles/main.scss';
import './fonts/inter/inter.css';
import './fonts/josefin/josefin.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router";
import App from './App'
import AboutPage from './pages/pages/about';
import ProjectPage from './pages/projects/show';
import ProjectsFilterPage from './pages/projects/filter';
import ProjectCreatePage from './pages/projects/create';
import NotFoundPage from './pages/notfound';
import CategoryPage from './pages/category';
import UsersPage from './pages/users';
import ProfileFeedPage from './pages/profiles/feed';
import ProfilesGridPage from './pages/profiles/grid';
import ProfileCreatePage from './pages/profiles/create';
import ProfilePage from './pages/profiles';
import AccountPage from './pages/account';
import AccountChangePage from './pages/account/change';
import AccountFavoritesPage from './pages/account/favorites';
import AccountFriendsPage from './pages/account/friendship';
import AccountNotificationPage from './pages/account/notification';
import AccountRequestsPage from './pages/account/requests';
import AccountSettingPage from './pages/account/settings';
import JobPage from './pages/landing/job';
import DirectoryPage from './pages/landing/directory';
import ListingPage from './pages/landing/listing';
import ContactPage from './pages/pages/contact';
import FaqPage from './pages/pages/faq';
import NotificationsPage from './pages/profiles/grid/notifications';
import Signin from './pages/auth/signin';
import Signup from './pages/auth/signup';
import HomePage from './pages/landing/home';
import FeatureDrawer from './@shared/drawers/feature'
import PersonsDrawer from './@shared/drawers/persons'
import ProfileDrawer from './@shared/drawers/profile'
import UserEditDrawer from './@shared/drawers/user_edit'
import UserDrawer from './@shared/drawers/user'

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <Routes>
      <Route path="/signup" element={<Signin />} />
      <Route path="/signin" element={<Signup />} />
      <Route path="/landing/home" element={<HomePage />} />
      <Route path="/landing/listing" element={<ListingPage />} />
      <Route path="/landing/directory" element={<DirectoryPage />} />
      <Route path="/landing/job" element={<JobPage />} />
      <Route path="/account/setting" element={<AccountSettingPage />} />
      <Route path="/account/requests" element={<AccountRequestsPage />} />
      <Route path="/account/notification" element={<AccountNotificationPage />} />
      <Route path="/account/friendship" element={<AccountFriendsPage />} />
      <Route path="/account/favorites" element={<AccountFavoritesPage />} />
      <Route path="/account/change" element={<AccountChangePage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/profiles/create" element={<ProfileCreatePage />} />
      <Route path="/profiles/feed" element={<ProfileFeedPage />} />
      <Route path="/profiles/grid" element={<ProfilesGridPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/category" element={<CategoryPage />} />
      <Route path="/projects/create" element={<ProjectCreatePage />} />
      <Route path="/projects/filter" element={<ProjectsFilterPage />} />
      <Route path="/projects" element={<ProjectPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/about" element={<AboutPage />} />
      {/** Models */}
       
      {/** Drawers */}
      <Route path="/drawers/feature" element={<FeatureDrawer />} />
      <Route path="/drawers/persons" element={<PersonsDrawer />} />
      <Route path="/drawers/profile" element={<ProfileDrawer />} />
      <Route path="/drawers/user_edit" element={<UserEditDrawer />} />
      <Route path="/drawers/user" element={<UserDrawer />} />
      {/** Not Found Pages */}
      <Route path="/" element={<App />} />
      <Route path="/:any/:any" element={<NotFoundPage />} />
      <Route path=":any" element={<NotFoundPage />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
